import { IEmail } from "interfaces";
import { Apis } from "utils";

export interface IEmailData {
  sendEmail(payload: IEmail): Promise<void>;
}

export class EmailData implements IEmailData {
  private collection = "emails";

  async sendEmail(payload: IEmail): Promise<void> {
    try {
      await Apis.current().post(`${this.collection}`, payload);
    } catch (err) {
      console.log(err);
    }
  }
}